import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../../backend/api";
// import { Button, ImgBox, Label, SelectBox, TagBox, TagData, TagItem, TagTitle } from "./styles";
import { DeleteIcon, DownIcon, TickIcon } from "../../../icons";
import { useTranslation } from "react-i18next";
import { addSelectObject } from "../../../store/actions/select";
// import { ErrorMessage } from "../form/styles";
import Search from "../search";
import { getValue } from "../../functions/dataFormat";
import Select, { components } from 'react-select'
import { useNavigate } from "react-router-dom";
// import { Variants, Variant } from "../../private/pages/recipe/styles";

const CustomOption = (props) => {
    const { data } = props;
    const [t] = useTranslation();
  
    return (
      <components.Option {...props}>
        {/* Customize how each option looks */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span>{t(data.value)}</span>
        </div>
      </components.Option>
    );
  };

const CustomSingleValue = ({ data, ...props }) => {
    const { t } = useTranslation();
    return (
        <components.SingleValue {...props}>
            {t(data.value)} {/* Apply translation */}
        </components.SingleValue>
    );
};

const CustomMultiValue = ({ data, ...props }) => {
    const { t } = useTranslation();
    return (
        <components.MultiValue {...props}>
            {t(data.value)} {/* Apply translation */}
        </components.MultiValue>
    );
};


function SelectReact({filter, handleFilterDelete,index,value,handleFilterChange,selectFilterView}) {
    const { apiType, selectApi, placeHolder,label ,params} = filter;
  const [optionsVisible, setOptionsVisible] = useState(false);
  const [updateValue, setUpdateValue] = useState({});
  const { i18n } = useTranslation();
  const [selectedLanguage] = useState(i18n.language || "de");
  const [defaultValue] = useState(filter.default);
  const [selectedId, setSelectedId] = useState(value);
  const [initialized, setInitialized] = useState(false);
  const [selectedValue, setSelectedValue] = useState(label);
  const [options, setOptions] = useState([]);
  const [optionsLabel, setOptionsLabel] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const selectData = useSelector((state) => state.select[selectApi]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toggleOptions = () => {
    setOptionsVisible(!optionsVisible);
  };
  const [searchValue, setSearchValue] = useState("");
  const [searchKey, setSearchKey] = useState("");
//   const handleChange = (event) => {
//     if (apiSearch) {
//       fetchData(updateValue, true, "", event.target.value.toString());
//       setSearchKey(event.target.value);
//     } else {
//       setSearchValue(event.target.value);
//       const filteredOptions = options.filter((option) => option.value?.toLowerCase().includes(event.target.value.toString().toLowerCase()));
//       setFilteredOptions(filteredOptions);
//       if (event.target.value.toString() === "") {
//         setFilteredOptions([]);
//       }
//     }
//     // clearTimeout(searchTimeoutRef.current);
//   };
  
  const fetchData = useCallback(
    async (item = {}, force = false, name = "", searchKey = "", params = {}) => {
      if (force && apiType === "API") {
        const optionHandler = (data) => {
          setOptions(data);
          setInitialized(true);
          try {
            const selected = data.filter((itemValue) => itemValue.id === selectedId)[0].value;
            setSelectedValue(selected ? selected : placeHolder);
          } catch {}
        };
        await getData({ ...item, searchKey, limit: 20, ...params }, `${selectApi}`, dispatch, navigate)
          .then((response) => {
            if (response.status === 200) {
              optionHandler(response.data);
              dispatch(addSelectObject(response.data, selectApi));
            } else if (response.status === 404) {
              setInitialized(false);
            } else {
              setInitialized(false);
            }
          })
          .catch((error) => {
            setInitialized(false);
          });
      } else if (apiType === "API") {
        const optionHandler = (data) => {
          setOptions(data);
          setInitialized(true);
          try {
            // if (bulkUpload) {
            //   const option = data.filter((itemValue) => itemValue.value === selectedId)[0];
            //   if (!setDefault) {
            //     const value = displayValue ? (showItem === "locale" && selectedLanguage === "de" ? option[selectedLanguage] : option[displayValue]) : showItem === "locale" && selectedLanguage === "de" ? option[selectedLanguage] : option.value;
            //     setSelectedValue(option ? option.value : placeHolder);
            //     console.log({placeHolder,showItem, id: option.id, value: value });
            //     onSelect(index, { id: option.id, value: value }, id, type);
            //     setSetDefault(true);
            //   }
            // } else {
            const option = data.filter((itemValue) => itemValue.id === selectedId)[0];
            setSelectedValue(option ? filter?.showItem === "locale" && selectedLanguage === "de" ? option[selectedLanguage] : option.value : placeHolder);
            // }
          } catch {}
        };
        if (selectData) {
          optionHandler(selectData);
        } else {
          if (initialized) {
          } else {
            await getData({ ...item }, `${selectApi}`, dispatch, navigate)
              .then((response) => {
                if (response.status === 200) {
                  optionHandler(response.data);
                  dispatch(addSelectObject(response.data, selectApi));
                } else if (response.status === 404) {
                  setInitialized(false);
                } else {
                  setInitialized(false);
                }
              })
              .catch((error) => {
                setInitialized(false);
              });
          }
        }
      } else if (apiType === "CSV") {
        const options = selectApi.split(",").map((item) => {
          return {
            id: item.trim(),
            value: item.trim().charAt(0).toUpperCase() + item.trim().slice(1),
          };
        });
        setOptions(options);
        setInitialized(true);
        try {
          const selected = options.filter((item) => item.id === selectedId)[0].value;
          
          setSelectedValue(selected ? selected : placeHolder);
        } catch {}
      } else if (apiType === "JSON") {
        const options = selectApi;
        setOptions(options);
        setInitialized(true);
        try {
          const selected = options.filter((item) => item.id === selectedId)[0].value;
          setSelectedValue(selected ? selected : placeHolder);
        } catch {}
      }
    },
    [apiType, selectApi, placeHolder]
  );

  useEffect(() => {
    let values = {};
    params?.forEach((item) => {
      values[item.name] = item.value;
    });
    fetchData(values);
  }, [selectApi, params, fetchData]);

  const selectRef = useRef(null);
//   useEffect(() => {
//     if (updateOn) {
//       const isObjectEqual = (obj1, obj2) => {
//         const keys1 = Object.keys(obj1 ?? {});
//         const keys2 = Object.keys(obj2 ?? {});
//         // console.log("Keys:",keys1, keys2);
//         if (keys1.length !== keys2.length) {
//           return false;
//         }

//         for (let key of keys1) {
//           if (obj1[key] !== obj2[key]) {
//             return false;
//           }
//         }

//         return true;
//       };
//       const equal = isObjectEqual(updateValue, updateValueparam);
//       if (!equal) {
//         setUpdateValue(updateValueparam);
//         let values = {};
//         params?.forEach((item) => {
//           if (!item.value) {
//             item.value = formValues?.[item.name] ?? "";
//           }
//           values[item.name] = item.value;
//         });
//         fetchData(updateValueparam, true, updateOn, "", values);
//       }
//     }
//   }, [updateValue, updateValueparam, fetchData, updateOn, params, formValues]);
//   useEffect(() => {
//     function handleClick(event) {
//       if (!selectRef?.current?.contains(event.target)) {
//         const listBox1 = listBox ?? false;
//         if (!listBox1) {
//           setOptionsVisible(false);
//         }
//         if (listBox1) {
//           setOptionsVisible(true);
//           setInitialized(true);
//         }
//       }
//     }
//     document.addEventListener("click", handleClick);
//     return () => {
//       document.removeEventListener("click", handleClick);
//     };
//   }, [listBox]);
  

useEffect(() => {
  if(Array.isArray(options)){
    let val = [];
    options.forEach(item => {
      val.push({label:item.id, value:item.value});
    })
    setOptionsLabel(val);
  }
}, [options])

console.log(options,optionsLabel);

  return (
    <div key={index} style={{display: 'flex', alignItems:'center', gap:'10px', width:'100%'}}>
        <div style={{width: 'calc(100% - 16px)'}}>
        <label style={{marginBottom:'2px'}}>{t(filter.label)}</label>
        <Select
            placeholder={t("select")}
            isMulti={filter.filterType==="multiSelect"}
            options={optionsLabel} // Assuming options are in the filterInput
            components={{ 
                Option: CustomOption,  // Custom options (already defined)
                SingleValue: CustomSingleValue,  // Custom single value display
                MultiValue: CustomMultiValue     // Custom multi value display
            }}
            onChange={(selectedOptions) => handleFilterChange(selectedOptions, filter)}
            value={filter.filterType==="multiSelect" ? optionsLabel.filter((option) => selectFilterView[filter.name]?.includes(option.label)) : optionsLabel.find((option) => selectFilterView[filter.name] === option.label)}
        />
        </div>
        <div style={{marginTop:'20px',cursor:'pointer'}} onClick={()=>handleFilterDelete(filter)}>
            <DeleteIcon/>
        </div>
    </div>
  );
}

export default SelectReact;
